var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDownarrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 17,
    viewBox: "0 0 27 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3284 10.1836L7.70344 15.8086C7.4925 16.0195 7.21125 16.125 6.93 16.125C6.61359 16.125 6.33234 16.0195 6.12141 15.8086L0.496407 10.1836C0.0393753 9.76172 0.0393753 9.02344 0.496407 8.60156C0.918282 8.14453 1.65656 8.14453 2.07844 8.60156L5.805 12.293V1.5C5.805 0.902344 6.29719 0.410156 6.89484 0.410156C7.45734 0.410156 8.055 0.902344 8.055 1.5V12.293L11.7464 8.60156C12.1683 8.14453 12.9066 8.14453 13.3284 8.60156C13.7855 9.02344 13.7855 9.76172 13.3284 10.1836ZM26.4684 7.93359C26.2575 8.14453 25.9763 8.25 25.695 8.25C25.3786 8.25 25.0973 8.14453 24.8864 7.93359L21.195 4.24219V15C21.195 15.6328 20.6677 16.125 20.07 16.125C19.5075 16.125 18.945 15.6328 18.945 15V4.24219L15.2184 7.93359C14.7966 8.39062 14.0583 8.39062 13.6364 7.93359C13.1794 7.51172 13.1794 6.77344 13.6364 6.35156L19.2614 0.726562C19.6833 0.269531 20.4216 0.269531 20.8434 0.726562L26.4684 6.35156C26.9255 6.77344 26.9255 7.51172 26.4684 7.93359Z",
    fill: "#45B549"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownarrowUp);
export default __webpack_public_path__ + "static/media/arrow-downarrow-up.39f01a51bec42a2807b2e5dfea8dafaf.svg";
export { ForwardRef as ReactComponent };